import {Component, input, ChangeDetectionStrategy} from "@angular/core"
import {MaterialCustomComponentUiDefinition, MaterialNode} from "@cm/material-nodes"
import {RgbCurveWidgetComponent} from "@material-editor/components/widgets/rgb-curve-widget/rgb-curve-widget.component"
import {ImageTextureSetWidgetComponent} from "@material-editor/components/widgets/image-texture-set-widget/image-texture-set-widget.component"
import {TextureRevisionWidgetComponent} from "@material-editor/components/widgets/texture-revision-widget/texture-revision-widget.component"
import {TextureFromSetWidgetComponent} from "@material-editor/components/widgets/texture-from-set-widget/texture-from-set-widget.component"
import {ColorRampWidgetComponent} from "@material-editor/components/widgets/color-ramp-widget/color-ramp-widget.component"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-material-custom-item",
    imports: [RgbCurveWidgetComponent, ImageTextureSetWidgetComponent, TextureRevisionWidgetComponent, TextureFromSetWidgetComponent, ColorRampWidgetComponent],
    templateUrl: "./material-custom-item.component.html",
    styleUrl: "./material-custom-item.component.scss",
})
export class MaterialCustomItemComponent {
    readonly $definition = input.required<MaterialCustomComponentUiDefinition>({alias: "definition"})
    readonly $material = input.required<MaterialNode>({alias: "material"})
    readonly $materialId = input.required<string>({alias: "materialId"})
    readonly $materialRevisionId = input<string | undefined>(undefined, {alias: "materialRevisionId"})
}
